import React, { useState, useRef, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Input from "../components/Input";
import "../App.css";
import FeedbackForm from "../components/FeedbackForm";
import SignOfPendingBox from "../components/SignOfPendingBox";
import { useAuth0 } from "@auth0/auth0-react";
import { jwtDecode } from "jwt-decode";
import Pusher from 'pusher-js';
import { RiMenu2Line } from "react-icons/ri";
import { AiOutlineClose } from "react-icons/ai";
import { IoIosStar } from "react-icons/io";
import logo from '../assets/Deli_Logo.svg'
import customPropertyImage from '../assets/customProperty.png'
import listingImage from '../assets/listing.png'
import SuggestionToast from "../components/SuggestionToast";
import PopUpClientNotes from "../components/chat/PopUpClientNotes";
import { toast } from "react-toastify";
import { createClient, addClientNote, updateClientNote, deleteClientNote, 
  unsaveClientList, saveClientList, getClients, getChatHistoryByClient, 
  getUser,
  getInitialQuestion} from "../utils/apiHandler";
import PopUpNewClient from "../components/PopUpNewClient";
import { useParams } from 'react-router-dom';
import SavedListings from "../components/chat/SavedListings";
import ChatComponent from "../components/chat/ChatComponent";
import Modal from "../components/modal";
import Response from "../components/Response";

const Chat = ({ token }) => {
  const [popUp, setPopUp] = useState(null); // Set to null initially
  const [feedback, setfeedback] = useState(false);
  const [messages, setMessages] = useState([]);
  const [pusherData, setPusherData] = useState([]);
  const chatContainerRef = useRef(null);
  const [dots, setDots] = useState(false);
  const [closeSidebar, setCloseSidebar] = useState(false);
  const { getIdTokenClaims, isAuthenticated, getAccessTokenWithPopup, logout, user } = useAuth0();
  const [suggestedQuestion, setSuggestedQuestion] = useState('');
  const [showSuggestionToast, setShowSuggestionToast] = useState(false);
  const [suggestionText, setSuggestionText] = useState('');
  const [clientList, setClientList] = useState([]);
  const [clientPopUp,setClientPopUp] = useState(false);
  const [notesPopup, setNotesPopup] = useState(false);
  const [listingNotes, setListingNotes] = useState([]);
  const [notesAnswerHash, setNotesAnswerHash] = useState('');
  const { queryParam } = useParams();
  const [clientId, setClientId] = useState(queryParam);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [tooltipDisplayed,setTooltipdispalyed] = useState(false);
  const [showSavedListing, setShowSavedListing] = useState(false);
  const [userQuestionCount, setUserQuestionCount] = useState(-1);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [openChatActive, setOpenChatActive] = useState(false);
  const [newClientActive, setNewClientActive] = useState(false);
  const [questionKey, setQuestionKey] = useState(null);
  const [initialExplanation, setInitialExplanation] = useState(null);
  const [userData, setUserData] = useState(null);
  const [tokenId, setTokenId] = useState(null);

  const closePanel = () => {
    setCloseSidebar(!closeSidebar);
  }

  const [inputMethod, setInputMethod] = useState('text'); // Default to text

  let timerId;

  useEffect(() => {
    setClientId(queryParam);
    setShowSavedListing(false);
    setMessages([]);

    if (queryParam) {
        setHistoryLoading(true);
        getChatHistoryByClient(queryParam, getIdTokenClaims, getAccessTokenWithPopup, logout)
        .then((history) => {
            let arrayOfObjects = [];
            for (const question in history) {
                let obj = history[question];
                arrayOfObjects.push({
                    question_key: obj.question_key,
                    message: obj.question,
                    history_response: true,
                    history_listings: obj.answers
                });
            }
            setMessages(arrayOfObjects);

            setTimeout(() => {
                setHistoryLoading(false);
            }, 1000);
        });

        // Call initialize when queryParam (clientId) changes
        getInitialQuestion(getIdTokenClaims, getAccessTokenWithPopup, logout, queryParam).then((res) => {
            console.log("Re-initializing chat:", res.chat_intelligence_key, "Client id:", queryParam);
            setQuestionKey(res.question_key);
            setInitialExplanation(res.explanation);
        });
    }

    window.addEventListener("blur", function() {
      // if(!timerId){
        timerId = setInterval(() => {
          toast.dismiss()
        }, 27000)
      // }
    });

    window.addEventListener('focus', function() {
      clearInterval(timerId);
    });

    if (window.innerWidth > 768) {
      setCloseSidebar(true);
    }
  }, [queryParam]);

  const getClientsList = async () => {
    var data = await getClients(getIdTokenClaims, getAccessTokenWithPopup, logout);
    if(data){
      setClientList(data);
    }else{
      setClientList([]);
    }
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const fetchUser = async () => {
    const idTokenClaims = await getIdTokenClaims();
    const idToken = idTokenClaims?.__raw;
    setTokenId(idToken);
    if(!idToken){
      console.error("No token found");
      return;
    }
    const response = await getUser(idToken)
      setUserQuestionCount(response.question_count);
      setUserData(response.user_details);
  }

  useEffect(() => {
    setPopUp(0); // No popup should be shown
    const authenticate = async () => {
      if (isAuthenticated) {
        const idTokenClaims = await getIdTokenClaims();
        const idToken = idTokenClaims?.__raw;

        if (idToken) {
          const decodedToken = jwtDecode(idToken);
          if (
            decodedToken?.accepted_terms &&
            decodedToken?.mls_active &&
            decodedToken?.broker_verified
          ) {
            setVerify(true);
          } else {
            setVerify(true);
          }
        }
        getClientsList();
        fetchUser();
        getInitialQuestion(getIdTokenClaims, getAccessTokenWithPopup, logout).then((res) => {
          console.log("Initialize chat_intelligence_key: ", res.chat_intelligence_key);
          setQuestionKey(res.question_key)
          setInitialExplanation(res.explanation)
        });
      }
    };

    authenticate();
  }, [getIdTokenClaims, isAuthenticated]);

  // state for verify popup
  const [verify, setVerify] = useState(false);
  useEffect(() => {
    // Scroll to the bottom of the chat container whenever the chat updates
    if (chatContainerRef.current || dots === false) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    // Subscribe to the Pusher channel and handle incoming responses
    const pusher = new Pusher(`${import.meta.env.VITE_REACT_APP_PUSHER_KEY}`, {
      cluster: `${import.meta.env.VITE_REACT_APP_PUSHER_CLUSTER}`,
    });

    const suggestionPusher = new Pusher(`${import.meta.env.VITE_REACT_APP_PUSHER_KEY}`, {
      cluster: `${import.meta.env.VITE_REACT_APP_PUSHER_CLUSTER}`,
    });

    const userId = user?.sub;
    const channelName = userId ? userId.replace('auth0|', '') : '';
    const channel = pusher.subscribe(channelName);
    const suggestionChannel = suggestionPusher.subscribe(`${import.meta.env.VITE_REACT_APP_PUSHER_SUGGESTION_CHANNEL}`);

    channel.bind('listing-response', function (data) {
      if(data.prompt){
        setSuggestionText(data.prompt);
      }

      setPusherData([...pusherData, data]);
    });

    suggestionChannel.bind(`${import.meta.env.VITE_REACT_APP_PUSHER_SUGGESTION_EVENT}`, (data) => {
      setSuggestedQuestion(data.suggested_question);
      setShowSuggestionToast(true);
    });

    return () => {
      pusher.unsubscribe(channelName);
      pusher.unsubscribe(suggestionChannel);
    };
  }, [user]);

  useEffect(() => {
    if(userQuestionCount === 0) {
      openModal()
    }
  }, [userQuestionCount])
  

  const handleToastClick = (question) => {
    setSuggestionText(question);
    setShowSuggestionToast(false);
  };

  const handleToastClose = (question) => {
    setShowSuggestionToast(false);
  };

  const handleClientSubmit = async (clientName, clientDescription) =>{
    if(!clientName || clientName === ''){
      toast.error(
        'Client name is required'
      );
    }else{
      const response = await createClient(getIdTokenClaims,clientName,clientDescription, getAccessTokenWithPopup, logout);
      if(response){
        setClientPopUp(false);
        getClientsList();
        toast.success(
          'Client Added Succesfully',
          {
            style: {
              fontSize: '12px',
              width: '100%',
            }
          }
        );
      }else{
        toast.error(
          'We are unable to create client at moment, please try again in few minutes',
          {
            style: {
              fontSize: '12px', // Adjust the font size as needed
              width: '100%',
            },
            toastClassName: 'custom-toast',
          }
        );
      }
    }
  }

  const handleNotesPopup = (notesList, answer_hash) => {
    setNotesAnswerHash(answer_hash);
    setListingNotes(notesList);
    setNotesPopup(!notesPopup);
  }

  const handleNotesPopupClose = () =>{
    setNotesPopup(false);
    setNotesAnswerHash('');
    setListingNotes([]);
  }

  const handleUpdateNotes = async (noteId, note, answer_hash) =>{
    if(noteId){
      let result = await updateClientNote(noteId,note,getIdTokenClaims, getAccessTokenWithPopup, logout);
      if(result){
        const index = listingNotes.findIndex(note => note.id === noteId);
        if (index !== -1) {
        const updatedNotes = [...listingNotes];
        updatedNotes[index] = { ...updatedNotes[index], text: note };
        setListingNotes(updatedNotes);
        toast.success(
          'Note updated successfully'
        );
      }
    }
    }else{
      let result = await addClientNote(clientId,answer_hash,note,getIdTokenClaims, getAccessTokenWithPopup, logout);
      if(result){
        let obj = {
          id : result,
          text : note,
          last_changed : new Date().toLocaleString()
        }
        const updatedNotes = [...listingNotes, obj];
        setListingNotes(updatedNotes)
        toast.success(
          'Note successfully added to your notes'
        );
      }
    }
  }

  const handleDeleteNotes = async (noteId) =>{
   let result = await deleteClientNote(noteId,getIdTokenClaims, getAccessTokenWithPopup, logout);
   if(result){
    const updatedNotes = listingNotes.filter(note => note.id !== noteId);
    setListingNotes(updatedNotes);
    toast.success(
      'Note deleted successfully from to your notes'
    );
   }
  }

  const saveUnsaveListing = async (isFavorite, answerhash) => {
      if(isFavorite)
        await saveClientList(getIdTokenClaims, clientId, answerhash, getAccessTokenWithPopup, logout);
      else
        await unsaveClientList(getIdTokenClaims,clientId, answerhash, getAccessTokenWithPopup, logout,);
  }

  const handleUpdateClient = async (chat_intelligence_key) =>{
      var filter = JSON.parse(chat_intelligence_key)
      if(clientId){
          var tempList = clientList;
          var index = tempList.findIndex(item => item.id.toString() === clientId);
          if(index > -1)
          {
            if(filter)
                tempList[index].chat_intelligence_key = filter;
            
            if(!tooltipDisplayed && tempList[index].chat_intelligence_key){
              tempList[index].tooltip = true;
              setTooltipdispalyed(true);
            }
            setClientList(tempList);
          }
      }
  }

  return (
    <div
      className={`bg-gradient-custom`}
    >
      {showSuggestionToast > 0 && (
        <SuggestionToast
          text={suggestedQuestion}
          delay={5000}
          onClick={() => handleToastClick(suggestedQuestion)}
          onToastClose={handleToastClose}
        />
      )}
      {popUp != 0 || feedback || notesPopup ? (
        <div className="absolute top-0 left-0 opacity-90 bg-[#3D4F6D] w-full h-dvh z-30"></div>
      ) : (
        ''
      )}

      {feedback && (
        <div className="relative ">
          <FeedbackForm setfeedback={setfeedback} />
        </div>
      )}

      {notesPopup && (
        <div>
          <PopUpClientNotes 
            notes = {listingNotes}
            answerHash = {notesAnswerHash}
            userName={user?.first_name + user?.last_name} 
            picture={user?.picture}
            setNotesPopup={handleNotesPopupClose}
            updateNotes = {handleUpdateNotes}
            deleteNote={handleDeleteNotes}
            isAuthenticated = {isAuthenticated}
          />
        </div>
      )}

      <div className="flex h-full">
      {
          user &&
          <Sidebar 
            setfeedback={setfeedback} 
            closeSidebar={closeSidebar} 
            setCloseSidebar={setCloseSidebar}
            userName={user?.first_name + user?.last_name} 
            picture={user?.picture} 
            width="348px" 
            clientsList={clientList}
            setClientPopUp={setClientPopUp}
            openChatActive={openChatActive}
            setOpenChatActive={setOpenChatActive}
            newClientActive={newClientActive}
            setNewClientActive={setNewClientActive}
            user={userData}
            tokenId={tokenId}
          />
        }

        {/* Sign off pending popup */}
        {!verify && (
          <div className="relative">
            <SignOfPendingBox setVerify={setVerify} />
          </div>
        )}
        <div className="flex flex-col h-full w-full">
          {
            clientId && !showSavedListing && (
              <div className={`absolute right-6 top-[9%] lg:top-6 p-3 rounded-full cursor-pointer transition-all ${closeSidebar ? '' : 'z-20' } hover:bg-[#E6E9F7]`} onClick={() => setShowSavedListing(true)}>
                <IoIosStar size={26} color="#0062ff"/>
              </div>
            )
          }
           <div id="mobileNav" className="flex relative justify-between items-center bg-white p-4 lg:hidden border-b border-gray-200" style={{ zIndex: 10 }}>
            <div className="flex items-center gap-4">
              <img width={40} src={logo} alt="DELI" />
            </div>
            <button onClick={closePanel} className="mx-2">
                {closeSidebar ? (
                  <AiOutlineClose size={28} />
                ) : (
                  <RiMenu2Line size={28} />
                )}
              </button>
          </div>
          {clientPopUp && (
            <div className="relative mx-4 lg:mx-0">
              <PopUpNewClient 
                setClientPopUp={setClientPopUp}
                setNewClientActive={setNewClientActive}
                onSubmit= {handleClientSubmit}
                setOpenChatActive={setOpenChatActive}
                clientId={clientId}
              />
            </div>
          )}
          <div
            className="chatContainer overflow-y-auto lg:ms-20 lg:me-20 mt-3 lg:mt-4 relative"
            ref={chatContainerRef}
          >
            <div className={`flex relative flex-col ${((historyLoading) && !showSavedListing) ? 'justify-center' : ''} h-full`}>
              <div className={showSavedListing ? 'hidden' : ''}>
              {
                historyLoading ? (
                  <div className="text-center">
                      <div className="flex items-center justify-center">
                          <div className="flex space-x-2 px-3 items-center justify-center">
                              <div className="w-2 h-2 bg-gray-500 rounded-full animate-dot-wave animate-dot-delay-1 mt-[8px]"></div>
                              <div className="w-2 h-2 bg-gray-500 rounded-full animate-dot-wave animate-dot-delay-2 mt-[8px]"></div>
                              <div className="w-2 h-2 bg-gray-500 rounded-full animate-dot-wave animate-dot-delay-3 mt-[8px]"></div>
                          </div>
                      </div>
                  </div>
                ) :
                (<>
                  <Response text={initialExplanation} inputMethod={inputMethod} />
                  {
                  messages && messages.map((message, index) => (
                          <ChatComponent key={index}
                                         userMessage={message.message}
                                         question_key={message.question_key}
                                         pusherData={pusherData}
                                         setDots={setDots}
                                         clientId={clientId}
                                         batch_count={message.batch_count}
                                         handleNotesPopup={handleNotesPopup}
                                         saveUnsaveListing={saveUnsaveListing}
                                         history_response={message.history_response}
                                         history_listings={message.history_listings}
                                         messageResponse={message.explanation}
                                         inputMethod={inputMethod}
                          />
                  ))}
                  </>
                )
              }
              </div>
              {
                clientId && showSavedListing && (
                  <SavedListings 
                  clientId={clientId} 
                  setShowSavedListing={setShowSavedListing} 
                  getIdTokenClaims={getIdTokenClaims}  
                  saveUnsaveListing = {saveUnsaveListing} 
                  handleNotesPopup = {handleNotesPopup}
                  getAccessTokenWithPopup = {getAccessTokenWithPopup} 
                  logout = {logout} />
                )
              }
              <div className={`hidden lg:block fixed top-[42%] ${closeSidebar ? 'left-[280px]' : 'left-[2px]'}`}>
                <button onClick={closePanel} className="p-3 cursor-pointer">
                  <span className='w-1 h-6 bg-gray-400 block rounded-full'></span>
                </button>
              </div>
            </div>
          </div>
          {/* Text Input */}
          {
            showSavedListing ? 
            <div className="mb-12 lg:mb-20"></div> :
            <div className="lg:ms-20 lg:me-20 mb-12 lg:mb-24">
              <Input
                setMessages={setMessages}
                messages={messages}
                popUp={popUp}
                feedback={feedback}
                verify={verify}
                suggestionText={suggestionText}
                getIdTokenClaims={getIdTokenClaims}
                getAccessTokenWithPopup={getAccessTokenWithPopup}
                logout={logout}
                clientId={clientId}
                updateClient={handleUpdateClient}
                questionKey={questionKey}
                setQuestionKey={setQuestionKey}
                setInputMethod={setInputMethod}
              />
            </div>
          }
        </div>
      </div>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {/* Centered Logo */}
        <img width={72} src={logo} alt="DELI" className="mx-auto" />
  
        {/* Heading */}
        <p className="text-[28px] font-[500] mt-[24px] text-[#101828]">Welcome to Deli</p>
  
        {/* Subtext */}
        <p className="text-[#667085] text-[14px] text-center">
          The ultimate tool to impress your clients in seconds. Deli is built to help you shine in two powerful ways.
        </p>

        <div className="p-4 mt-[12px]">
         <div className="grid grid-cols-2 gap-8">
           {/* Grid Item 1 */}
           <div className="border border-[#EAECF0] p-8 pt-4 flex flex-col items-center text-center">
             <img className="w-[60%] h-[150px] object-contain" src={customPropertyImage} alt="DELI" />
             <p className="font-semibold text-[16px] mt-2 leading-[20px]">Create Custom Property Landing Pages</p>
             <p className="text-[12px] text-[#667085] mt-[8px]">
               Simply provide a property address and your client’s preferences, and Deli will craft a personalized landing page. Showcase the home in a way that speaks directly to your client’s needs, making every interaction more impactful.
             </p>
           </div>

           {/* Grid Item 2 */}
           <div className="border border-[#EAECF0] p-8 pt-4 flex flex-col items-center text-center">
             <img className="w-[70%] h-[150px] object-contain" src={listingImage} alt="DELI" />
             <p className="font-semibold text-[16px] mt-2 leading-[20px]">Find Perfect Listings for Your Clients</p>
             <p className="text-[12px] text-[#667085] mt-[8px]">
               Tell Deli what your client is looking for, and it will deliver tailored property recommendations. Each listing includes unique descriptions that highlight exactly what matters most to them, ensuring no two experiences are the same.
             </p>
           </div>
         </div>
        </div>

          {/* Close Button */}
          <button
            onClick={closeModal}
            className="mt-4 px-4 py-2 bg-[#0062FF] text-white rounded-[44px] w-[400px] hover:bg-blue-600"
          >
            Got It!
          </button>
    </Modal>

    </div>
  );

};

export default Chat;